export default "__VITE_ASSET__BHhGUOgX__"